<template>
    <div class="main-layout__container">
        <div class="content__header content__header--one-item-per-line">
            <div class="content-header__back">
                <UIBackButton
                    :text="'К списку городов'"
                    :to="router.resolve({ name: 'HandbookCities' }).href"
                />
            </div>

            <div class="content-header__title">Редактирование города</div>

            <div class="content-header__background content-header__background--add-edit-page"></div>
        </div>

        <UILoader v-if="isCityLoading" class="editable" />

        <template v-else>
            <div class="content__body">
                <div class="form__content">
                    <div class="form__fields">
                        <UIInput
                            id="cityName"
                            v-model="form.name"
                            label="Название города*"
                            :error-message="errors?.name?.join() ?? ''"
                        />
                    </div>
                </div>
            </div>

            <div class="content__footer">
                <div class="form__actions">
                    <UISimpleButton
                        button-type="outlined"
                        @clicked="goToCitiesPage"
                    >
                        Выйти без сохранения
                    </UISimpleButton>

                    <UISimpleButton
                        :loading="saveLoading"
                        @clicked="saveCity"
                    >
                        Сохранить
                    </UISimpleButton>
                </div>
            </div>
        </template>
    </div>
</template>

<script lang="ts" setup>
    import { onMounted, ref } from 'vue';
    import { useRouter, useRoute } from 'vue-router';

    import { City, CityUpdateForm, CityUpdateFormErrors } from '@/types/city.type.ts';

    import useCityRepository from '@/repositories/city/useCityRepository.ts';
    import useLoading from '@/utils/useLoading.ts';
    import useNotifications from '@/utils/useNotifications.ts';

    import UIBackButton from '@/components/ui/UIBackButton/UIBackButton.vue';
    import UIInput from '@/components/ui/UIInput/UIInput.vue';
    import UILoader from '@/components/ui/UILoader/UILoader.vue';
    import UISimpleButton from '@/components/ui/UISimpleButton/UISimpleButton.vue';

    const router = useRouter();
    const route = useRoute();
    const { getCity, updateCity } = useCityRepository();
    const { showSuccess } = useNotifications();

    const form = ref({
        name: '',
    });
    const { isLoading: isCityLoading, setLoading: setCityLoading } = useLoading();
    const saveLoading = ref<boolean>(false);
    const errors = ref<CityUpdateFormErrors | null>(null);

    const cityId = route.params.city_id as unknown as number;

    function saveCity(): void {
        saveLoading.value = true;
        errors.value = null;

        updateCity(cityId, mapUpdatedCityFromForm())
            .then(() => {
                showSuccess({
                    title: 'Изменения в городе сохранены',
                });

                goToCitiesPage();
            })
            .catch((updateCityErrors: CityUpdateFormErrors) => {
                errors.value = updateCityErrors;
            })
            .finally(() => {
                saveLoading.value = false;
            });
    }

    function mapUpdatedCityFromForm(): CityUpdateForm {
        return {
            name: form.value.name,
        };
    }

    function goToCitiesPage(): void {
        router.push({ name: 'HandbookCities' });
    }

    onMounted(() => {
        setCityLoading(true);

        getCity(cityId).then((city: City) => {
            form.value = {
                name: city.name,
            };

            setCityLoading(false);
        });
    });
</script>
